if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // === RRB Pixel-Fix v2 (06.05.2026) ===
          // Published Custom Event "rrb_product_added_to_cart" über mehrere Pfade.
          // Ein Custom Web Pixel im Shopify Admin (Settings -> Customer events)
          // lauscht darauf und feuert Meta AddToCart direkt im Browser via fbq.
          try {
            if (response && response.variant_id) {
              var __cur = response.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
              var __qty = response.quantity || 1;
              var __price = (response.final_price || 0) / 100;
              var __lineTotal = response.final_line_price != null ? response.final_line_price / 100 : __price * __qty;

              var __payload = {
                productId: String(response.product_id || ''),
                variantId: String(response.variant_id || ''),
                productTitle: response.product_title || response.title || '',
                variantTitle: response.variant_title || '',
                sku: response.sku || '',
                vendor: response.vendor || '',
                productType: response.product_type || '',
                quantity: __qty,
                price: __price,
                lineTotal: __lineTotal,
                currency: __cur
              };

              if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
                window.Shopify.analytics.publish('rrb_product_added_to_cart', __payload);
              }
              if (window.webPixelsManager && typeof window.webPixelsManager.publishCustomEvent === 'function') {
                window.webPixelsManager.publishCustomEvent('rrb_product_added_to_cart', __payload);
              }
            }
          } catch (__e) {
            if (window.console && console.warn) console.warn('[rrb-pixel-v2]', __e);
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
